import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-10 items-start"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-y-2" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-y-2" }
const _hoisted_4 = { class: "flex items-start mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt mr-2" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("u", null, "выберите другой город", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_geocoder = _resolveComponent("geocoder")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить отправной пункт?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      (!_ctx.geocode_state.is_opened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_the_input, {
                class: "-mt-2",
                placeholder: `Наименование ${_ctx.isSender ? 'отправителя' : 'получателя'}`,
                value: _ctx.state.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.title) = $event)),
                "is-invalid": _ctx.state_form$.title.$error,
                "validation-errors": _ctx.state_form$.title.$errors
              }, null, 8, ["placeholder", "value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                placeholder: "Имя и фамилия",
                value: _ctx.state.full_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.full_name) = $event)),
                "is-invalid": _ctx.state_form$.full_name.$error,
                "validation-errors": _ctx.state_form$.full_name.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_phone_number, {
                class: "mt-2",
                placeholder: "Телефон",
                value: _ctx.state.phone,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.phone) = $event)),
                "is-invalid": _ctx.state_form$.phone.$error,
                "validation-errors": _ctx.state_form$.phone.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_phone_number, {
                class: "mt-2",
                placeholder: "Дополнительный телефон",
                value: _ctx.state.additional_phone,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.additional_phone) = $event)),
                "is-invalid": _ctx.state_form$.additional_phone.$error,
                "validation-errors": _ctx.state_form$.additional_phone.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_select, {
                value: _ctx.state.city_id,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.city_id) = $event)),
                placeholder: "Выберите город",
                "is-invalid": _ctx.state_form$.city_id.$error,
                "validation-errors": _ctx.state_form$.city_id.$errors,
                loading: _ctx.data_state.cities.is_loading,
                options: _ctx.data_state.cities.list,
                failed: _ctx.data_state.cities.is_failed,
                "error-text": "При получении списка городов произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                "infinite-scroll": "",
                onRefresh: _ctx.refreshCities,
                onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreCities(_ctx.data_state.cities.pagination.current_page + 1))),
                onSearch: _ctx.searchCity,
                onOptionBySearch: _ctx.unshiftFindedCity,
                onChange: _ctx.onCitySelect,
                disabled: Boolean(_ctx.receiverCityId)
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh", "onSearch", "onOptionBySearch", "onChange", "disabled"]),
              (_ctx.isReceiver && !_ctx.isFtl)
                ? (_openBlock(), _createBlock(_component_the_select, {
                    key: 0,
                    value: _ctx.pvz_state.distribution_center_id,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pvz_state.distribution_center_id) = $event)),
                    placeholder: "ПВЗ",
                    loading: _ctx.data_state.pvz.is_loading,
                    options: _ctx.data_state.pvz.list,
                    failed: _ctx.data_state.pvz.is_failed,
                    disabled: !_ctx.state.city?.id,
                    "error-text": "Нет склада в выбранном городе, пожалуйста, выберите другой город!",
                    "search-by": "name",
                    "select-by": "id",
                    label: "name",
                    "infinite-scroll": "",
                    onRefresh: _ctx.refreshPVZ,
                    onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMorePVZ(_ctx.data_state.pvz.pagination.current_page + 1))),
                    onChange: _ctx.onPVZSelect,
                    searchable: false,
                    class: "mt-3"
                  }, null, 8, ["value", "loading", "options", "failed", "disabled", "onRefresh", "onChange"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_input, {
                  value: _ctx.state.full_address,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.full_address) = $event)),
                  disabled: "",
                  class: "w-3/5",
                  placeholder: "Адрес",
                  "is-invalid": _ctx.state_form$.full_address.$error,
                  "validation-errors": _ctx.state_form$.full_address.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_button, {
                  class: "mt-3 ml-3 primary text small w-2/5",
                  disabled: _ctx.isAddressDisabled,
                  onClick: _ctx.onStartGeocode
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" Указать ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              (!_ctx.pvz_state.is_selected)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_checkbox, {
                      value: _ctx.warehouse_state.is_setted,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.warehouse_state.is_setted) = $event)),
                      label: _ctx.isSender ? 'Самопривоз' : 'Самовывоз',
                      onChange: _ctx.toggleWarehouse
                    }, null, 8, ["value", "label", "onChange"]),
                    (_ctx.warehouse_state.is_setted && !_ctx.warehouse_state.warehouse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                          _createTextVNode(" Склад в выбранном городе не найден, пожалуйста "),
                          _hoisted_7
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_input, {
                      value: _ctx.state.index,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.index) = $event)),
                      placeholder: "Индекс",
                      disabled: Boolean(_ctx.state.warehouse_id)
                    }, null, 8, ["value", "disabled"]),
                    _createVNode(_component_the_input, {
                      value: _ctx.state.house,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.house) = $event)),
                      placeholder: "Дом",
                      disabled: Boolean(_ctx.state.warehouse_id)
                    }, null, 8, ["value", "disabled"]),
                    _createVNode(_component_the_input, {
                      value: _ctx.state.office,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.office) = $event)),
                      placeholder: "Номер квартиры / офиса",
                      disabled: Boolean(_ctx.state.warehouse_id)
                    }, null, 8, ["value", "disabled"])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_the_textarea, {
                value: _ctx.state.comment,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.comment) = $event)),
                placeholder: "Комментарий к адресу",
                autoheight: "",
                rows: 4
              }, null, 8, ["value"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_geocoder, {
            key: 1,
            city: _ctx.state.city,
            latitude: _ctx.state.latitude,
            longitude: _ctx.state.longitude,
            "full-address": _ctx.state.full_address,
            onSetAddress: _ctx.onSetAddress
          }, null, 8, ["city", "latitude", "longitude", "full-address", "onSetAddress"]))
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}